import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SUBSCRIPTION_MODULE_TYPE } from '../../constants';
import { setPaymentSteps } from '../../actions/stripe';

export default function PaymentSteps({
    selectedStep,
    pageType = false,
    isAdvisor
}) {
    const { stripePlans } = useSelector((state) => state.stripe);
    const dispatch = useDispatch()
    const steps = [
        'Quotation details',
        pageType
            ? 'Add your details'
            : stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS
                ? 'Add funds'
                : (
                    stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL ||
                    stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.CUSTOM ||
                    stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN ||
                    stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN
                )
                    ? 'Amount'
                    : 'Select Quantity',
        'Select payment method',
        'Pay',
        'Confirmation', // ✅ NEW
    ];

    /* ================= MOBILE VIEW ================= */
    const MobileView = () => (
        <div className="mobileStepWrapper">
            {selectedStep > 1 && (
                <button
                    className="mobileBackBtn"
                    onClick={() => dispatch(setPaymentSteps(selectedStep - 1))}
                >
                    ←
                </button>
            )}
            <h4 className="mobileStepTitle">
                {steps[selectedStep - 1]}
            </h4>
        </div>
    );

    /* ================= DESKTOP VIEW ================= */
    const DesktopView = () => (
        <div className="row indicatorSectionMain">
            {steps.map((label, index) => {
                const step = index + 1;

                return (
                    <div key={step} className="col p-0 indicatorSection">
                        <div className={`indicatorCircelLine ${index === 0 ? 'indicatorCircelLineLeft' :
                            index === steps.length - 1 ? 'indicatorCircelLineRight' :
                                'indicatorCircelLineCenter'}`}>

                            {index !== 0 && (
                                <div className={`ConnectLineLeft ${selectedStep > step ? 'ConnectLineActive' : ''}`} />
                            )}

                            {selectedStep > step
                                ? isAdvisor ? <img src="assets/img/steptickAdvisor.svg" alt="" /> : <img src="assets/img/steptick.svg" alt="" />
                                : <div className={`Iconcircle ${selectedStep >= step ? 'IconcircleActive' : ''}`} />
                            }

                            {index !== steps.length - 1 && (
                                <div className={`ConnectLineLeft ${selectedStep > step + 1 ? 'ConnectLineActive' : ''}`} />
                            )}
                        </div>

                        <p className={`indicatorSectiondiv ${selectedStep >= step ? 'indicatorSectiondivActive' : ''}`}>
                            {label}
                        </p>
                    </div>
                );
            })}

        </div>
    );

    return (
        <>
            <div className="desktopOnly">
                <DesktopView />
            </div>
            {/* 
            <div className="mobileOnly">
                <MobileView />
            </div> */}
        </>
    );
}
